import { render, staticRenderFns } from "./CmsB2BGroupsOverviewTable.vue?vue&type=template&id=e72a9b0a&scoped=true"
import script from "./CmsB2BGroupsOverviewTable.vue?vue&type=script&lang=ts"
export * from "./CmsB2BGroupsOverviewTable.vue?vue&type=script&lang=ts"
import style0 from "./CmsB2BGroupsOverviewTable.vue?vue&type=style&index=0&id=e72a9b0a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e72a9b0a",
  null
  
)

export default component.exports